/**
 * Normalizes a phone number to E.164 format (+61...)
 */
export const normalizePhone = (input) => {
    if (!input) return "";
    const digits = input.replace(/\D/g, "");

    if (digits.startsWith("0")) {
        return `+61${digits.slice(1)}`;
    }

    if (digits.startsWith("61")) {
        return `+${digits}`;
    }

    // Defensive: if it's already +61...
    if (input && input.startsWith("+61")) return input;

    return input;
};

/**
 * Converts a normalized phone number (+61...) to the canonical userId format (04...)
 */
export const toUserId = (normalizedPhone) => {
    if (!normalizedPhone) return null;
    const trimmed = String(normalizedPhone).trim();
    if (trimmed.startsWith("+61")) return "0" + trimmed.slice(3);
    return trimmed;
};

/**
 * Formats a phone number for display (04xx xxx xxx)
 */
export const formatDisplayNumber = (value) => {
    if (!value) return "";
    const rawDigits = String(value).replace(/\D/g, "");
    const digits = rawDigits.startsWith("061") && rawDigits.length > 3
        ? `0${rawDigits.slice(3)}`
        : rawDigits.startsWith("61") && rawDigits.length > 2
            ? `0${rawDigits.slice(2)}`
            : rawDigits;
    let formatted = "";

    if (digits.length <= 4) {
        formatted = digits;
    } else if (digits.length <= 7) {
        formatted = `${digits.slice(0, 4)} ${digits.slice(4)}`;
    } else if (digits.length <= 10) {
        formatted = `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7, 10)}`;
    } else {
        formatted = `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7, 10)} ${digits.slice(10)}`;
    }

    return formatted;
};

export const parsePhoneInput = (value) => {
    if (!value) return "";
    const rawDigits = String(value).replace(/\D/g, "");
    const digits = rawDigits.startsWith("061") && rawDigits.length > 3
        ? `0${rawDigits.slice(3)}`
        : rawDigits.startsWith("61") && rawDigits.length > 2
            ? `0${rawDigits.slice(2)}`
            : rawDigits;

    return digits.slice(0, 10);
};

/**
 * Validates if a string is a valid mobile number
 */
export const isValidAuMobile = (raw) => {
    const digits = (raw || "").replace(/\D/g, "");
    // Accept either "04xxxxxxxx" (10 digits) or "+614xxxxxxxx" (11 digits after 61)
    if (digits.length === 10 && digits.startsWith("04")) return true;
    if (digits.length === 11 && digits.startsWith("614")) return true;
    if (digits.length === 12 && digits.startsWith("0614")) return true; // defensive
    return false;
};

/**
 * Validates email format
 */
export const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || "").trim());
};
